<script lang="ts">
    import type {Option} from "../models/option";
    import {createEventDispatcher} from "svelte";

    export let value: number;
    export let options: Option[];

    const dispatch = createEventDispatcher();

    function cast(opt: any): Option {
        return opt;
    }

    function setValue(v:any) {
        console.log(v);
        value = v;
        dispatch('valueChanged', {value: v});
    }

</script>

<ul class="simple-select-options w-100">
    {#each options as option}
        <li class="simple-select-option {value === option.value? 'selected' : ''}"
            on:click={() => setValue(option.value)}>{option.label}</li>
    {/each}
</ul>
<style lang="scss">

  * {

    margin-bottom: 0;

  }

  ul {
    list-style-type: none !important;
    padding: 0;

    li {

      padding-top: 10px;
      padding-bottom: 10px;
      border-bottom: 2px solid #F8F7F7;

      &.simple-select-option.selected {

        font-weight: bold;
      }

      &:last-of-type {
        border-bottom: 0;
      }

    }
  }

</style>
